var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComponent541(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_54_1",
    "data-name": "Component 54 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_52_2",
    "data-name": "Component 52 \\u2013 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16137",
    "data-name": "Path 16137",
    d: "M22.5,0A22.5,22.5,0,1,1,0,22.5,22.5,22.5,0,0,1,22.5,0Z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(9.81 12.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M50.272,36.449a10.3,10.3,0,0,1-2.966.812,5.178,5.178,0,0,0,2.271-2.856A10.337,10.337,0,0,1,46.3,35.658a5.168,5.168,0,0,0-8.8,4.71,14.658,14.658,0,0,1-10.644-5.4,5.169,5.169,0,0,0,1.6,6.894,5.127,5.127,0,0,1-2.339-.647c0,.022,0,.044,0,.065a5.167,5.167,0,0,0,4.142,5.063,5.184,5.184,0,0,1-2.332.089,5.169,5.169,0,0,0,4.824,3.586A10.424,10.424,0,0,1,25.1,52.162,14.685,14.685,0,0,0,47.71,39.79c0-.224-.005-.447-.015-.668a10.471,10.471,0,0,0,2.577-2.673Z",
    transform: "translate(-25.103 -34.028)",
    fill: "#003a6f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent541);
export default __webpack_public_path__ + "static/media/Component 54 – 1.97db2f99f75ee501ce7b8cea9ce94951.svg";
export { ForwardRef as ReactComponent };